@if (type === 'linear') {

<div
  [class]="'h-[7px] w-full overflow-hidden rounded-full bg-slate200 ' + trackClasses"
  role="progressbar"
  [attr.aria-valuenow]="progress">

  <div
    [class]="
      'h-full rounded-full bg-indigo600 transition-all duration-300 ease-out ' + progressClasses
    "
    [style.width.%]="progress"
  ></div>
</div>

} @else {

<div class="relative mx-auto w-full max-w-[220px] aspect-[2/1]">

  <svg
    viewBox="0 0 180 100"
    preserveAspectRatio="xMidYMid meet"
    class="h-full w-full">

    <!-- Background Arc -->
    <path
      d="M20 90 A70 70 0 0 1 160 90"
      fill="none"
      stroke="#DBE4F3"
      stroke-width="12"
      stroke-linecap="round" />

    <!-- Progress Arc -->
    <path
      d="M20 90 A70 70 0 0 1 160 90"
      fill="none"
      stroke="#4F46E5"
      stroke-width="12"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset"
      style="
        transition: stroke-dashoffset .5s ease;
        transform-origin:center;
      " />
  </svg>

  <!-- Percentage -->
<div class="absolute inset-x-0 bottom-1.5 flex justify-center">
  <p class="text-lg 2xl:text-2xl font-semibold leading-none text-slate900">
    {{ progress }}%
  </p>
</div>

</div>

}